import { Component, OnInit, ChangeDetectorRef } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ActivatedRoute, Router } from '@angular/router';
import { SseFormService } from '../../../services/sse/sseForm.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { SubmitDiagDirective } from '../../../services/diagnostics/submit-diag.directive';

@Component({
    selector: 'app-sse-checklist',
    imports: [
    SubmitDiagDirective,
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatRadioModule,
    MatFormFieldModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatIconModule
],
    templateUrl: './sse-checklist.component.html',
    styleUrl: './sse-checklist.component.css'
})
export class SseChecklistComponent implements OnInit {
  form!: FormGroup;
  checklistId: string | null = null;
  sseName: string | null = null;
  mentorName: string | null = null;
  daysSinceCreated: number | null = null;
  loading: boolean = true;
  isSubmitting: boolean = false;
  error: string | null = null;
  warningMessage = '';

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private sseFormService: SseFormService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.checklistId = this.route.snapshot.paramMap.get('id');
    if (this.checklistId) {
      this.loadChecklist(this.checklistId);
    } else {
      this.loading = false;
    }
  }

  initializeForm(): void {
    this.form = this.fb.group({
      sseInitials1: [null],
      mentorInitials1: [null],
      sseInitials2: [null],
      mentorInitials2: [null],
      sseInitials3: [null],
      mentorInitials3: [null],
      sseInitials4: [null],
      mentorInitials4: [null],
      sseInitials5: [null],
      mentorInitials5: [null],
      sseInitials6: [null],
      mentorInitials6: [null],
      sseInitials7: [null],
      mentorInitials7: [null],
      sseInitials8: [null],
      mentorInitials8: [null],
      sseInitials9: [null],
      mentorInitials9: [null],
      sseInitials10: [null],
      mentorInitials10: [null],
      sseInitials11: [null],
      mentorInitials11: [null],
      sseInitials12: [null],
      mentorInitials12: [null],
      sseInitials13: [null],
      mentorInitials13: [null],
      sseInitials14: [null],
      mentorInitials14: [null],
      sseInitials15: [null],
      mentorInitials15: [null],
      sseInitials16: [null],
      mentorInitials16: [null],
      sseInitials17: [null],
      mentorInitials17: [null],
      sseInitials18: [null],
      mentorInitials18: [null],
      sseInitials19: [null],
      mentorInitials19: [null],
      sseInitials20: [null],
      mentorInitials20: [null],
      sseInitials21: [null],
      mentorInitials21: [null],
      sseInitials22: [null],
      mentorInitials22: [null],
      sseInitials23: [null],
      mentorInitials23: [null],
      sseInitials24: [null],
      mentorInitials24: [null],
      sseInitials25: [null],
      mentorInitials25: [null],
      sseInitials26: [null],
      mentorInitials26: [null],
      sseInitials27: [null],
      mentorInitials27: [null],
      sseInitials28: [null],
      mentorInitials28: [null],
      sseInitials29: [null],
      mentorInitials29: [null]
    });
  }

  loadChecklist(id: string): void {
    // acquireTokenSilent() resolves outside Angular's zone, so the HTTP callback
    // chain runs outside the zone and NgZone-based CD never fires.
    // ChangeDetectorRef.detectChanges() is an explicit, synchronous CD trigger
    // that works regardless of zone state — use it after every state mutation.
    this.sseFormService.getSseListById(id).subscribe(
      (response) => {
        const checklistData = response?.data || {};
        this.form.patchValue(checklistData);

        this.sseFormService.getForm(checklistData.indexId).subscribe(
          (indexResponse) => {
            const indexData = indexResponse?.data || {};
            this.sseName = indexData.section1?.hrName || null;
            this.mentorName = indexData.section2?.ccName || null;
            this.cdr.detectChanges();
          },
          (error) => {
            console.error('Error fetching SSE index:', error);
            this.error = 'Failed to fetch related SSE data.';
            this.cdr.detectChanges();
          }
        );

        if (checklistData.createdAt) {
          const createdDate = new Date(checklistData.createdAt);
          const currentDate = new Date();
          this.daysSinceCreated = Math.floor(
            (currentDate.getTime() - createdDate.getTime()) / (1000 * 60 * 60 * 24)
          );
        }

        this.loading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Error loading checklist:', error);
        this.error = 'Failed to load checklist. Please try again later.';
        this.loading = false;
        this.cdr.detectChanges();
      }
    );
  }

// Update checklist
  updateChecklist(): void {
    if (this.isSubmitting) return;

    if (this.form.invalid) {
      return;
    }

    if (this.checklistId) {
      this.isSubmitting = true;
      this.warningMessage = '';
      this.sseFormService.updateSseList(this.checklistId, this.form.value).subscribe(
        () => {
          this.isSubmitting = false;
          this.router.navigate(['/sse-hub']);
        },
        (error) => {
          console.error('Error updating checklist:', error);
          this.isSubmitting = false;
          this.warningMessage = 'Submission failed. Please check your connection and try again — your form data has been preserved.';
          this.cdr.detectChanges();
        }
      );
    }
  }
}
